import type {Callbacks, ObservableChange} from './fluxProxy';
import {forceUpdate, getRenderingRef} from '@stencil/core';
// const forceUpdate  = ()=>{};
// const getRenderingRef  = ()=>undefined;
import {debounce} from '../../../components/guided/subcomponents/utils';

import {makeLogger} from '../../../logger/logger';

const {
  debug,
  //info,
  //warn,
  //err
} = makeLogger({
  pathToCurrentFile: 'utils/libs/dataflux/fluxStencilIntegration.ts',
});


const isConnected = (maybeElement: any) => !('isConnected' in maybeElement) || maybeElement.isConnected; //eslint-disable-line @typescript-eslint/no-explicit-any


// direct ripoff from stencil store code
// https://github.com/ionic-team/stencil-store/blob/723044332049199c3ee7ebb4e0f64ab2c3f1fdb2/src/subscriptions/stencil.ts#L16
const cleanupElements = debounce((map: Map<string, unknown[]>) => {
    for (const key of map.keys()) {
      map.set(key, map.get(key).filter(isConnected));
    }
}, 2_000);

type Element = string;
type ObservedProperty = string;
type ElementUpdateMap = Map<ObservedProperty,Element[]>;
// the mechanism is a ripoff from stencil store,
// https://github.com/ionic-team/stencil-store/blob/723044332049199c3ee7ebb4e0f64ab2c3f1fdb2/src/subscriptions/stencil.ts
export const StencilSubscription = ():Callbacks=>{

    const elementsMap: ElementUpdateMap = new Map<ObservedProperty, Element[]>();

    // Code to update tracked components when observed property changes
    const updateFunctionalComponents = (c:ObservableChange)=>{
        const elements = elementsMap.get(c.currentPath as string);

        debug(`Updating components flux:${c.currentPath} on components`, elements);
        //if elements support forceUpdate, we execute it, so that - component updates
        if (elements) {
          elementsMap.set(c.currentPath as string, elements.filter(forceUpdate));
        }
        cleanupElements(elementsMap);
    };

    return {
      onGet: [
      // When prop is read within Component, especially Functional Component
      // we keep track of these components to forceUpdate them when prop changes in onAdd/onUpdate
        (c)=> {
            if (typeof getRenderingRef !== 'function')
              return;
            const elm = getRenderingRef();

            if(!elm) return;

            const propName = c.currentPath;

            const items = elementsMap.get(propName);
            if (!items) {
              elementsMap.set(propName, [elm]);
              debug(`Stencil Proxy integration attached for ${propName} as new subscription`, elm, elementsMap);
              return;
            }
            if (!items.includes(elm)) {
              items.push(elm);
              debug(`Stencil Proxy integration attached for ${propName} `, elm, elementsMap);
              return;
            }
            //If code goes here - there is a known subscription on the field from the given element,
            // we can take no action. No logs to keep the clutter out!
            //debug(`Stencil Proxy integration is already attached for ${propName} `, {},elm, elementsMap);

        }],
      //on delete property, we remove it from the map!
      onDelete: [
        (c)=>{
            elementsMap.delete(c.currentPath as string);
            debug(`Stencil Proxy integration deleting ${c.currentPath} `);
            cleanupElements(elementsMap);
        }
      ],
      onUpdate: [updateFunctionalComponents],
      onAdd: [updateFunctionalComponents],
    };
};
